import { useSnapshot } from "valtio"
import { airChargesBookingStore, chargesBookingStore1, chargesBookingValidationStore, fclChargesBookingStore } from "../mybooksv3/booking-commonstate"
import { cargoStore, configStore, containerStore, contractsStore, EntityV2Store, } from "../state/CommonState";
import { useEffect, useState } from "react";
import Utils from "../util/Utils";
import { TableComboInput, TableEdit, TableSelect } from "../components/AgComponents";
import { TableLabel } from "../v3-componets/AgTableLabel"
import chargedetails from "../assets/images/chargedetails.svg";
import { Card } from "../v3-componets/AgCard"
import { Headspan } from "../v3-componets/AgHeadspan"
import { chargesData1, currencyList } from "../StaticData";
import QuoteCalcV2 from "../util/quote-calc-v2";
import { editStore } from "./editStore.js";
import { FormProvider, useForm, useWatch } from "react-hook-form";
import { LCLChargesCompFromNew } from "../quick-quotev3/editchargenew.js";
import AiChargeParse, { fillChargesStore, AiChargeHistory, loadAiHistory, getAiHistory } from "../components/AiChargeParse";

export default function EditCharge(props) {
    // AI charge history of this route: loaded each time the editor opens, saved with the route (save below)
    useEffect(() => { loadAiHistory("quickQuote", Date.now(), editStore.contract?.aiChargeHistory) }, [])
    let setOpenChargeModel = props.setOpenChargeModel
    let routes = props.routes
    useSnapshot(contractsStore)
    useSnapshot(editStore)
    const charges = useForm({
        defaultValues: {
            groupedByCategory: {},
            list: [],
            pkb: [],
            initialLength: 0
        }
    })
    const { control, setValue } = charges;
    const watchedList = useWatch({
        control,
        name: 'list',
    });
    const watchedPkb = useWatch({
        control,
        name: 'pkb',
    });
    useEffect(() => {
        if (JSON.stringify(contractsStore.current) != JSON.stringify(editStore.contract)) {
            contractsStore.current = JSON.parse(JSON.stringify(editStore.contract))
        }
    }, [editStore.contract])

    const save = async (type) => {
        let l = JSON.parse(JSON.stringify(editStore.contract))
        l["aiChargeHistory"] = getAiHistory("quickQuote")
        chargesBookingValidationStore.isNew = false
        let chargeStoreToValidate;
        if (type.indexOf("FCL") >= 0) {
            type = "FCL"
        }
        if (type.indexOf("FCL") >= 0) {
            fclChargesBookingStore.calculateChargesTotalsindex("list", editStore.contract.emptycontainerweight);
            chargeStoreToValidate = fclChargesBookingStore;
        } else if (type.indexOf("Air") >= 0) {
            airChargesBookingStore.checktotal = airChargesBookingStore.checktotal + 1
            cargoStore.calculateCargoTotals()
            airChargesBookingStore.calculateChargesTotalsindex('list')
            chargeStoreToValidate = airChargesBookingStore;
        } else {
            chargeStoreToValidate = { list: watchedList }
        }
        if (type.indexOf("FCL") >= 0) {
            let kz = true
            if (chargeStoreToValidate && containerStore.list.length > 0) {
                containerStore.list.map((container) => {
                    chargeStoreToValidate.list.map((charge, index) => {
                        if (kz) {
                            kz = chargesBookingValidationStore.isValidCharge(
                                `${container.containerType}perWM`,
                                index,
                                'list'
                            )
                        }
                    })
                })
            }
            if (!kz) {
                configStore.setModalMessage(`Please check the charges detail fields`);
                return false;
            }
        } else if (type.indexOf("Air") >= 0) {
            let kz = true
            if (chargeStoreToValidate &&
                !chargeStoreToValidate.list.every((charge, index) =>
                    Object.keys(charge).every((chargeKey) =>
                        chargesBookingValidationStore.isValidCharge(chargeKey, index, 'list')
                    )
                )
            ) {
                kz = false
            }
            if (!kz) {
                configStore.setModalMessage(`Please check the charges detail fields`);
                return false;
            }
        } else {
            let kz = true
            if (watchedList &&
                !watchedList.every((charge, index) =>
                    Object.keys(charge).every((chargeKey) =>
                        chargesBookingValidationStore.isValidChargelclform(chargeKey, index, watchedList)
                    )
                )
            ) {
                kz = false
            }
            if (!kz) {
                configStore.setModalMessage(`Please check the charges detail fields`);
                return false;
            }
        }
        if (type.indexOf("FCL") >= 0) {
            l.shipmentType = `FCL (${l.stuffingType}/${l.deStuffingType})`
        }
        l['orginalchargesList'] = JSON.parse(JSON.stringify(chargeStoreToValidate.list))
        l['chargesList'] = []
        l['shipperchargesList'] = []
        l['consigneechargesList'] = []
        l['pkb'] = []
        let z = l['orginalchargesList']
        if (type.indexOf("LCL") >= 0 || type.indexOf("Air") >= 0) {
            for (let i = 0; i < z.length; i++) {
                if (z[i]['total'] != 0) {
                    z[i]['isIncluded'] = 'Yes'
                    if (z[i]['onaccount'] == 'On Your Account') {
                        l['chargesList'].push(z[i])
                    }
                    if (z[i]['onaccount'] == "Shipper's Account") {
                        l['shipperchargesList'].push(z[i])
                    }
                    if (z[i]['onaccount'] == "Consignee's Account") {
                        l['consigneechargesList'].push(z[i])
                    }
                }
            }
        } else {
            for (let i = 0; i < z.length; i++) {
                let l1 = false
                containerStore.list.map((container) => {
                    if (z[i][container.containerType + 'total'] != 0) {
                        l1 = true
                    }
                })
                if (l1) {
                    z[i]['isIncluded'] = 'Yes'
                    if (z[i]['onaccount'] == 'On Your Account') {
                        l['chargesList'].push(z[i])
                    }
                    if (z[i]['onaccount'] == "Shipper's Account") {
                        l['shipperchargesList'].push(z[i])
                    }
                    if (z[i]['onaccount'] == "Consignee's Account") {
                        l['consigneechargesList'].push(z[i])
                    }
                }
            }
        }
        if (watchedPkb.length > 0 && watchedPkb[0]["total"] != undefined && watchedPkb[0]['total'] != 0) {
            l['pkb'] = JSON.parse(JSON.stringify(watchedPkb))
            l['pkb'][0]['id'] = 1
            l['pkb'][0]['isIncluded'] = 'Yes'
        }
        let k = new QuoteCalcV2(l).recalc()
        l['quoteValue'] = k.quoteValue
        l['quoteValueUSD'] = k.quoteValueUSD
        editStore.contract = JSON.parse(JSON.stringify(l))
        if (k.quoteValue != 0) {
            routes[editStore.subscript]['dummyContract'] = JSON.parse(JSON.stringify(editStore.contract))
            let a = []
            a.push(routes[editStore.subscript])
            for (let i = 0; i < routes.length; i++) {
                if (i != editStore.subscript) {
                    a.push(routes[i])
                }
            }
            editStore.routes = JSON.parse(JSON.stringify(a))
            editStore.savecharge = true
            setOpenChargeModel(false)
        } else {
            configStore.setModalMessage(`On your account is empty.`);
        }
    }
    useEffect(() => {
        if (JSON.stringify(containerStore.list) != JSON.stringify(editStore.contract.containerList)) {
            containerStore.list = JSON.parse(JSON.stringify(editStore.contract.containerList))
        }
        if (JSON.stringify(cargoStore.cargoList) != JSON.stringify(editStore.contract.cargoList)) {
            cargoStore.cargoList = JSON.parse(JSON.stringify(editStore.contract.cargoList))
        }
        cargoStore.calculateCargoTotals()
        let c = []
        if (editStore.contract.orginalchargesList != undefined) {
            c = editStore.contract.orginalchargesList
        }
        if (c != undefined && c.length == 0) {
            const addchargelist = (chargesList, ch, onaccount) => {
                let z = chargesList
                for (let i = 0; i < z.length; i++) {
                    if (z[i]['isIncluded'] = 'Yes') {
                        z[i]['onaccount'] = onaccount
                        z[i]["id"] = ch.length + 1
                        ch.push(z[i])
                    }
                }
                return ch
            }
            if (editStore.contract.chargesList != undefined) {
                c = addchargelist(editStore.contract.chargesList, c, "On Your Account")
            }
            if (editStore.contract.shipperchargesList != undefined) {
                c = addchargelist(editStore.contract.shipperchargesList, c, "Shipper's Account")
            }
            if (editStore.contract.consigneechargesList != undefined) {
                c = addchargelist(editStore.contract.consigneechargesList, c, "Consignee's Account")
            }
            chargesBookingValidationStore.isNew = true
        }
        if (c.length > 0) {
            let type = editStore.contract.shipmentType
            if (type.indexOf("FCL") >= 0) {
                type = "FCL"
            }
            let k = JSON.parse(JSON.stringify(c))
            if (type.indexOf("FCL") >= 0 && JSON.stringify(fclChargesBookingStore.list) != JSON.stringify(k)) {
                fclChargesBookingStore.initialLength = k.length;
                fclChargesBookingStore.list = k;
            } else if (type.indexOf("Air") >= 0 && JSON.stringify(airChargesBookingStore.list) != JSON.stringify(k)) {
                airChargesBookingStore.initialLength = k.length;
                airChargesBookingStore.list = k;
            } else if (JSON.stringify(watchedList) != JSON.stringify(k)) {
                setValue('initialLength', k.length)
                setValue('list', k)
                let scope = editStore.contract.shipmentScope
                const data1 = chargesData1[type.toLowerCase() + scope.toLowerCase()];
                if (editStore.contract.pkb == undefined || editStore.contract.pkb.length == 0) {
                    setValue('pkb', JSON.parse(JSON.stringify(data1.pkb)))
                } else {
                    let pkb = editStore.contract.pkb
                    if (Utils.isObject(editStore.contract.pkb)) {
                        pkb = [editStore.contract.pkb]
                        pkb[0]['category'] = 'PKB'
                    }
                    if (pkb[0]['chargeDescription'] == 'Freight Commission') {
                        setValue('pkb', JSON.parse(JSON.stringify(pkb)))
                    } else {
                        setValue('pkb', JSON.parse(JSON.stringify(data1.pkb)))
                    }
                }
            }
        }
    }, [JSON.stringify(editStore.contract)])
    return (<>
        {editStore.contract.shipmentType.indexOf("LCL") >= 0 ? <FormProvider {...charges}>
            <LCLChargesCompFromNew form={charges} listkey={"list"} aiHistory={{ scope: "quickQuote" }} contract={editStore.contract} />
            <hr /><LCLChargesCompFromNew form={charges} listkey={"pkb"} hide={true} contract={editStore.contract} />
        </FormProvider> : ""}
        {editStore.contract.shipmentType.indexOf("Air") >= 0 ? <AirChargesComp /> : ""}
        {editStore.contract.shipmentType.indexOf("FCL") >= 0 ? <FCLChargesComp /> : ""}
        <div className="columns is-vcentered is-multiline">
            <div className="column is-12" style={{ textAlign: "right" }}>
                <div
                    className="field is-grouped"
                    style={{ display: "flex", justifyContent: "flex-start" }}
                >
                    <div className="control">
                        <button
                            className="button"
                            style={{
                                backgroundColor:
                                    process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
                                color: "#fff",
                            }}
                            onClick={async (e) => {
                                save(editStore.contract.shipmentType)
                            }}
                        >
                            Save
                        </button>
                    </div>
                    <div className="control">
                        <button
                            class="button is-danger"
                            onClick={() => {
                                setOpenChargeModel(false)
                            }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div></div>


    </>)
}

export function LCLChargesComp() {
    const [grandTotal, setGrandTotal] = useState(0.0)
    const [shipTotal, setShipTotal] = useState(0.0)
    const [conTotal, setConTotal] = useState(0.0)
    const onaccount = ['On Your Account', `Consignee's Account`, `Shipper's Account`]
    const [volumeDiscount, setVolumeDiscount] = useState(0)
    const [showtotal, setShowtotal] = useState(false)

    useSnapshot(cargoStore)
    useSnapshot(editStore)
    console.log('ChargesComp rendering')
    let [space, setSpace] = useState('')

    let imChargesStore = useSnapshot(chargesBookingStore1)

    useEffect(() => {
        let list = chargesBookingStore1.list
        for (let i = 0; i < list.length; i++) {
            if (!list[i].onaccount || !list[i].onaccount.length) list[i].onaccount = 'On Your Account'
        }
        // if (!grandTotal) {
        calculateFinalTotal()
        let vd = chargesBookingStore1.list.find(e => e.chargeDescription == 'Volume Discount')
        if (vd) {
            let of = chargesBookingStore1.list.filter(e => e.chargeDescription == 'Ocean Freight')
            if (of && of.length) {
                if (vd.total > 0) vd.total *= -1
                let voldis = vd.total
                let e = of[0]
                if (e.perCBM > 0 ||
                    e.perTon > 0 ||
                    e.minimum > 0 ||
                    e.maximum > 0 ||
                    e.perShipment > 0) {
                    e.perShipment = (e.total > 0 ? e.total : e.total * -1) + voldis
                    if (e.perShipment > 0) e.perShipment *= -1
                    console.log('\n\n\nSetting pershipment of OF to', e.perShipment, '\n-----------\n')
                }
            }
            // }
        }
    }, [imChargesStore])
    useEffect(() => {
        setVolumeDiscount(0)
        cargoStore.calculateCargoTotals()
        imChargesStore.calculateLCLChargesTotals()
        calculateFinalTotal()
    }, [imChargesStore.checktotal])
    useEffect(() => {
        let entity = EntityV2Store.list.find((e) => e.entityId === editStore.contract.entityId)
        if (entity) {
            let sscope = editStore.contract.shipmentScope
            sscope = sscope.toLowerCase()
            let country = '' + entity.entityCountry
            country = country.toLowerCase()
            let cecisorigin = false
            let cecisdestination = false
            let por = ('' + editStore.contract.portOfLoading).toLowerCase()
            let pod = ('' + editStore.contract.finalPlaceOfDelivery).toLowerCase()
            let q = editStore.contract
            if (entity._id == "TBA" && q.isfromAgragaEnquiry != undefined && q.isfromAgragaEnquiry == 'Yes' && q.countryFromEnquiry != undefined) {
                country = q.countryFromEnquiry.toLowerCase()
            }
            if (country.includes('hong kong')) {
                cecisorigin = por.includes('hong kong')
                cecisdestination = pod.includes('hong kong')
            } else {
                cecisorigin = por.includes(country)
                cecisdestination = pod.includes(country)
            }

            chargesBookingStore1.list.map((e) => {
                if (sscope.length != 0 && country.length != 0 && por.length != 0 && pod.length != 0) {
                    if (e.onaccount != undefined) {
                        if (onaccount.indexOf(e.onaccount) == -1) {
                            e.onaccount = "On Your Account"
                        }
                    }
                }
                return e
            })
        }
        console.log('DETECTED CHANGES=', editStore.contract.entityId, editStore.contract.portOfReceipt, editStore.contract.portOfDischarge)
    }, [
        editStore.contract.entity, editStore.contract.entityId, editStore.contract.portOfLoading,
        editStore.contract.finalPlaceOfDelivery, editStore.contract.shipmentScope
    ])
    const deleteRec = (id) => {
        //if (id <= imChargesStore.initialLength) return
        const index = chargesBookingStore1.list.findIndex(e => e.id === id)
        let records = chargesBookingStore1.list
        records = [...records]
        records.splice(index, 1)
        for (let i = 0; i < records.length; i++) {
            records[i].id = i + 1
        }
        if (id <= chargesBookingStore1.initialLength) {
            chargesBookingStore1.initialLength = chargesBookingStore1.initialLength - 1
        }
        chargesBookingStore1.list = records
        if (chargesBookingStore1.list.length == 0) {
            let obj = imChargesStore.newRec
            obj = { ...obj }
            chargesBookingStore1.list.push({ ...obj, id: chargesBookingStore1.list.length + 1 })
        }
        //console.log('AFTER DELETE=', JSON.stringify(chargesBookingStore1.cargoList))
    }
    const Ts = ({ i, name, dataList, ...otherProps }) => <TableSelect
        record={chargesBookingStore1.list[i]} name={name} dataList={dataList} isValid={chargesBookingValidationStore.isValidCharge(name, i)} {...otherProps} />
    const Te = ({ i, name }) => {
        const e = chargesBookingStore1.list[i]
        if ((name === 'chargeDescription' && i < chargesBookingStore1.initialLength) || e.chargeDescription == 'Volume Discount') {
            return <TableLabel record={chargesBookingStore1.list[i]} name={name} />
        } else {
            return <TableComboInput isblue={true} callback={(e) => { chargesBookingStore1.list[i][name] = e }} record={chargesBookingStore1.list[i]} name={name} isValid={chargesBookingValidationStore.isValidCharge(name, i)} />
        }

    }
    const Tn = ({ i, name, ...otherProps }) => {
        const e = chargesBookingStore1.list[i]
        if ((e.disabled && e.disabled.indexOf(name) >= 0) || e.chargeDescription == 'Volume Discount')
            return (
                <input disabled='true' style={{ width: '3rem', backgroundColor: '#dddddd', border: 'none' }} />
            )
        else return (
            <TableEdit record={chargesBookingStore1.list[i]} name={name} type='number' isValid={chargesBookingValidationStore.isValidCharge(name, i)} {...otherProps} />
        )
    }
    const ifNotFCL = () => editStore.contract.shipmentType.indexOf('FCL') < 0

    let finalTotal = 0.0
    const calculateFinalTotal = () => {
        let tot = 0
        let shiptot = 0
        let contot = 0
        chargesBookingStore1.list.map((e) => {
            let erate = configStore.getExchangeRateinr(e)
            if (!erate || erate === 0) erate = 1.0
            if (e.chargeDescription == 'Volume Discount') {
                if (e.total > 0) e.total *= -1
                setVolumeDiscount(e.total * erate)
            } else {
                if (e.onaccount && e.onaccount.startsWith('Cons')) contot += e.total * erate
                else if (e.onaccount && e.onaccount.startsWith('Ship')) shiptot += e.total * erate
                else {
                    tot += e.total * erate
                }
            }
        })
        if (tot && showtotal == false) {
            setShowtotal(true)
        }
        setGrandTotal(tot)
        setShipTotal(shiptot)
        setConTotal(contot)
        return finalTotal;
    }

    return (
        <>
            <hr />
            <Card onClick={(e) => {
                e.nativeEvent.preventDefault()
                e.preventDefault()
                e.nativeEvent.stopPropagation()
                e.stopPropagation()

            }}>
                <span><img src={chargedetails} /></span><Headspan color="#00000" fontSize="14px" fontWeight="900" data=" Charge Details" />
                <AiChargeParse historyScope="quickQuote" historyKey="list" shipmentType="LCL" onCharges={(l) => fillChargesStore(chargesBookingStore1, "list", l, () => { cargoStore.calculateCargoTotals(); chargesBookingStore1.calculateLCLChargesTotals() })} /><AiChargeHistory scope="quickQuote" chargeKey="list" />
                <div className="table-container" onClick={(e) => {
                    e.nativeEvent.preventDefault()
                    e.preventDefault()
                    e.nativeEvent.stopPropagation()
                    e.stopPropagation()

                }} >
                    <table style={{ border: "none", width: "100%" }}>
                        <thead>
                            {ifNotFCL() ?
                                <tr>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th colSpan='4' style={{ border: "solid 0.5px #4BA7DD", backgroundColor: "#4BA7DD", color: "#fff", fontWeight: "900", padding: "10px", textAlign: "center" }}>Per Unit</th>
                                    <th></th>
                                    <th ></th>
                                    <th></th>
                                </tr> : <></>
                            }
                            <tr style={{ fontWeight: "900", border: "solid 0.5px #D4D4D4" }}>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", width: '5rem' }}>ID</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", width: '20rem' }}>Charge Description</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>On Account</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>Currency</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>Per CBM</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>Per Ton</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>Minimum</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>Maximum</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>Per shipment</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right' }}>Total</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                imChargesStore.list
                                    .map((e, i) => {
                                        {
                                            if (e.chargeDescription == 'Volume Discount')
                                                return <></>
                                            else
                                                return <tr key={e.id} style={{ border: "solid 0.5px #D4D4D4", backgroundColor: (i % 2) == 1 ? "#F3F3F3" : "none" }}>
                                                    <td style={{ color: "#555555", padding: "10px" }}>{e.id}</td>
                                                    <td style={{ color: "#555555", padding: "10px" }}><Te i={i} name='chargeDescription' /></td>
                                                    <td style={{ color: "#555555", padding: "10px" }}><Ts i={i} name='onaccount' dataList={onaccount} /></td>
                                                    <td style={{ color: "#555555", padding: "10px" }}><Ts i={i} name='currency' dataList={configStore.getCurrencyList()} /></td>
                                                    <td style={{ color: "#555555", padding: "10px", textAlign: 'center' }}><Tn i={i} name='perCBM' /></td>
                                                    <td style={{ color: "#555555", padding: "10px", textAlign: 'center' }}><Tn i={i} name='perTon' /></td>
                                                    <td style={{ color: "#555555", padding: "10px", textAlign: 'center' }}><Tn i={i} name='minimum' /></td>
                                                    <td style={{ color: "#555555", padding: "10px", textAlign: 'center' }}><Tn i={i} name='maximum' /></td>
                                                    <td style={{ color: "#555555", padding: "10px", textAlign: 'center' }}><Tn i={i} name='perShipment' /></td>
                                                    <td style={{ color: "#555555", padding: "10px", textAlign: 'right' }}>{
                                                        (e.total != 0 && e.currency != '') ? Utils.N(e.total, e.currency) : ''
                                                    }</td>
                                                    <td style={{ color: "#555555", padding: "10px", textAlign: 'center' }}>

                                                        <div className="field has-addons">
                                                            <p className="control">
                                                                <button className="button is-danger is-inverted"
                                                                    onClick={() => {
                                                                        deleteRec(e.id)
                                                                        setSpace(space === '' ? ' ' : '')
                                                                    }}>
                                                                    <span className="icon">
                                                                        <i className="fas fa-trash"></i>
                                                                    </span>
                                                                </button>
                                                            </p>
                                                            {
                                                                (i == imChargesStore.list.length - 1 || (JSON.stringify(chargesBookingStore1.list).indexOf('Volume Discount') != -1 && i == imChargesStore.list.length - 2)) ? <p className="control">
                                                                    <button className="button is-success is-inverted"
                                                                        onClick={() => {
                                                                            let obj = imChargesStore.newRec
                                                                            obj = { ...obj }
                                                                            chargesBookingStore1.list.push({ ...obj, id: imChargesStore.list.length + 1 })
                                                                            //chargesBookingStore1.calculateLCLChargesTotals()
                                                                            setSpace(space === '' ? ' ' : '')
                                                                        }}>
                                                                        <span className="icon is-small">
                                                                            <i className="fas fa-plus"></i>
                                                                        </span>
                                                                    </button>
                                                                </p> : ""
                                                            }
                                                        </div>
                                                    </td>
                                                </tr>
                                        }
                                    }
                                    )
                            }
                            {!showtotal ? <tr style={{ border: "solid 0.5px #D4D4D4" }}><td colSpan={11} style={{ textAlign: 'right' }}>
                                <button className="button is-info is-inverted"

                                    onClick={(e) => {
                                        e.nativeEvent.preventDefault()
                                        e.preventDefault()
                                        e.nativeEvent.stopPropagation()
                                        e.stopPropagation()
                                        setVolumeDiscount(0)
                                        cargoStore.calculateCargoTotals()
                                        let voldis = imChargesStore.calculateLCLChargesTotals()
                                        calculateFinalTotal()
                                        setSpace(space === '' ? ' ' : '')
                                    }}>
                                    <span className="icon is-small">
                                        <i className="fas fa-calculator"></i>
                                    </span>
                                </button>
                            </td></tr> : ""}

                            {
                                showtotal ? <>
                                    <tr style={{ border: "solid 0.5px #D4D4D4" }}>
                                        <td colSpan={8}></td>
                                        <td colSpan={2} style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right', fontSize: '1.1rem', fontWeight: "900" }}><strong>{Utils.N(grandTotal)}</strong></td>
                                        <td style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right', fontSize: '1.1rem', fontWeight: "900" }} rowSpan={(conTotal && shipTotal && volumeDiscount) ? 6 : (volumeDiscount && (conTotal || shipTotal)) ? 5 : (volumeDiscount && !conTotal && !shipTotal) ? 4 : (conTotal && shipTotal) ? 4 : (conTotal || shipTotal) ? 3 : 2}>
                                            <button className="button is-info is-inverted"

                                                onClick={() => {
                                                    setVolumeDiscount(0)
                                                    cargoStore.calculateCargoTotals()
                                                    let voldis = imChargesStore.calculateLCLChargesTotals()
                                                    calculateFinalTotal()
                                                    setSpace(space === '' ? ' ' : '')
                                                }}>
                                                <span className="icon is-small">
                                                    <i className="fas fa-calculator"></i>
                                                </span>
                                            </button>
                                        </td>
                                    </tr>
                                    {
                                        volumeDiscount != 0 &&
                                        <>
                                            <tr style={{ border: "solid 0.5px #D4D4D4" }}>
                                                <td colSpan={8} style={{ textAlign: 'right', color: "#555555", padding: "10px", fontWeight: "900" }}>Volume Discount :</td>
                                                <td colSpan={2} style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right', fontSize: '1.1rem', fontWeight: "900" }}><strong>{Utils.N(volumeDiscount)}</strong></td>
                                            </tr>
                                            <tr style={{ border: "solid 0.5px #D4D4D4" }}>
                                                <td colSpan={8} style={{ textAlign: 'right', color: "#555555", padding: "10px", fontWeight: "900" }}>TOTAL :</td>
                                                <td colSpan={2} style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right', fontSize: '1.1rem', fontWeight: "900" }}><strong>{Utils.N(grandTotal + volumeDiscount)}</strong></td>
                                            </tr>
                                        </>
                                    }
                                    {
                                        shipTotal > 0 &&
                                        <tr style={{ border: "solid 0.5px #D4D4D4" }}>
                                            <td colSpan={9} style={{ textAlign: 'right', color: "#555555", padding: "10px", fontWeight: "900" }}>Total of On Shipper's Account : </td>
                                            <td style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right', fontSize: '1.1rem', fontWeight: "900" }}><strong>{Utils.N(shipTotal)}</strong></td>
                                        </tr>
                                    }
                                    {
                                        conTotal > 0 &&
                                        <tr style={{ border: "solid 0.5px #D4D4D4" }}>
                                            <td colSpan={9} style={{ textAlign: 'right', color: "#555555", padding: "10px", fontWeight: "900" }}>Total of On Consignee's Account : </td>
                                            <td style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right', fontSize: '1.1rem', fontWeight: "900" }}><strong>{Utils.N(conTotal)}</strong></td>
                                        </tr>
                                    }
                                </> : ""
                            }
                        </tbody>
                    </table></div></Card>
        </>
    )
}

export function AirChargesComp(props) {
    const [grandTotal, setGrandTotal] = useState(0.0)
    const [shipTotal, setShipTotal] = useState(0.0)
    const [conTotal, setConTotal] = useState(0.0)
    const onaccount = ['On Your Account', `Consignee's Account`, `Shipper's Account`]
    useSnapshot(editStore)
    console.log('ChargesComp rendering')
    let [space, setSpace] = useState('')

    let key = "list"
    if (props.keylist != undefined) {
        key = props.keylist
    }
    let initialLength = "initialLength" + key.replace("list", "")
    let imChargesStore = useSnapshot(airChargesBookingStore)


    useEffect(() => {
        let list = airChargesBookingStore[key]
        for (let i = 0; i < list.length; i++) {
            if (!list[i].onaccount || !list[i].onaccount.length) list[i].onaccount = 'On Your Account'
        }
        calculateFinalTotal()

    }, [imChargesStore])
    useEffect(() => {
        cargoStore.calculateCargoTotals()
        airChargesBookingStore.calculateChargesTotalsindex(key)
        calculateFinalTotal()
    }, [imChargesStore.checktotal])
    useEffect(() => {
        let entity = EntityV2Store.list.find((e) => e.entityId === editStore.contract.entityId)
        if (entity) {
            let sscope = editStore.contract.shipmentScope
            sscope = sscope.toLowerCase()
            let country = '' + entity.entityCountry
            country = country.toLowerCase()
            let cecisorigin = false
            let cecisdestination = false
            let por = ('' + editStore.contract.portOfLoading).toLowerCase()
            let pod = ('' + editStore.contract.finalPlaceOfDelivery).toLowerCase()
            let q = editStore.contract
            if (entity._id == "TBA" && q.isfromAgragaEnquiry != undefined && q.isfromAgragaEnquiry == 'Yes' && q.countryFromEnquiry != undefined) {
                country = q.countryFromEnquiry.toLowerCase()
            }
            if (country.includes('hong kong')) {
                cecisorigin = por.includes('hong kong')
                cecisdestination = pod.includes('hong kong')
            } else {
                cecisorigin = por.includes(country)
                cecisdestination = pod.includes(country)
            }
            airChargesBookingStore[key].map((e, i) => {
                if (sscope.length != 0 && country.length != 0 && por.length != 0 && pod.length != 0) {
                    if (e.onaccount != undefined) {
                        if (onaccount.indexOf(e.onaccount) == -1) {
                            e.onaccount = "On Your Account"
                        }
                    }
                }
                return e
            })
        }
        console.log('DETECTED CHANGES=', editStore.contract.entityId, editStore.contract.portOfReceipt, editStore.contract.portOfDischarge)
    }, [
        editStore.contract.entity, editStore.contract.entityId, editStore.contract.portOfLoading,
        editStore.contract.portOfDischarge, editStore.contract.shipmentScope
    ])
    const deleteRec = (id) => {
        //if (id <= imChargesStore[initialLength]) return
        const index = airChargesBookingStore[key].findIndex(e => e.id === id)
        let records = airChargesBookingStore[key]
        records = [...records]
        records.splice(index, 1)
        for (let i = 0; i < records.length; i++) {
            records[i].id = i + 1
        }
        if (id <= airChargesBookingStore[initialLength]) {
            airChargesBookingStore[initialLength] = airChargesBookingStore[initialLength] - 1
        }
        airChargesBookingStore[key] = records
        if (airChargesBookingStore[key].length == 0) {
            let obj = imChargesStore.newRec
            obj = { ...obj }
            airChargesBookingStore[key].push({ ...obj, id: airChargesBookingStore[key].length + 1 })
        }
    }
    const Ts = ({ i, name, dataList }) => <TableSelect
        record={airChargesBookingStore[key][i]} name={name} dataList={dataList} isValid={chargesBookingValidationStore.isValidCharge(name, i, key)} />
    const Te = ({ i, name }) => {
        const e = airChargesBookingStore[key][i]
        if (name === 'chargeDescription' && i < airChargesBookingStore[initialLength])
            return <TableLabel record={airChargesBookingStore[key][i]} name={name} />
        return (
            <TableComboInput
                record={airChargesBookingStore[key][i]} name={name} dataList={configStore.getChargeDescriptionList('air')} isValid={chargesBookingValidationStore.isValidCharge(name, i, key)} />
            // <TableEdit record={airChargesBookingStore[key][i]} name={name} isValid={chargesBookingValidationStore.isValidCharge(name, i,key)}/>
        )
    }
    const Tn = ({ i, name }) => {
        const e = airChargesBookingStore[key][i]
        if (e.disabled && e.disabled.indexOf(name) >= 0)
            return (
                <input disabled='true' style={{ backgroundColor: '#dddddd', border: 'none' }} />
            )
        else return (
            <TableEdit record={airChargesBookingStore[key][i]} name={name} type='number' isValid={chargesBookingValidationStore.isValidCharge(name, i, key)} />
        )
    }

    const ifNotFCL = () => editStore.contract.shipmentType.indexOf('FCL') < 0

    let finalTotal = 0.0
    const calculateFinalTotal = () => {
        let tot = 0
        let shiptot = 0
        let contot = 0
        airChargesBookingStore[key].map((e) => {
            let erate = configStore.getExchangeRateinr(e)
            if (!erate || erate === 0) erate = 1.0
            if (e.onaccount && e.onaccount.startsWith('Cons')) contot += e.total * erate
            else if (e.onaccount && e.onaccount.startsWith('Ship')) shiptot += e.total * erate
            else {
                tot += e.total * erate
            }
        })

        setGrandTotal(tot)
        setShipTotal(shiptot)
        setConTotal(contot)

        return finalTotal
    }

    return (
        <>
            <hr />
            <Card onClick={(e) => {
                e.nativeEvent.preventDefault()
                e.preventDefault()
                e.nativeEvent.stopPropagation()
                e.stopPropagation()

            }} >
                <span><img src={chargedetails} /></span><Headspan color="#00000" fontSize="14px" fontWeight="900" data={" Charge Details" + (props.heading != undefined && props.heading.length > 0 ? " - " + props.heading : "")} />
                <AiChargeParse historyScope="quickQuote" historyKey={key} shipmentType="Air" onCharges={(l) => fillChargesStore(airChargesBookingStore, key, l, () => { cargoStore.calculateCargoTotals(); airChargesBookingStore.calculateChargesTotalsindex(key) })} /><AiChargeHistory scope="quickQuote" chargeKey={key} />
                <div className="table-container" onClick={(e) => {
                    e.nativeEvent.preventDefault()
                    e.preventDefault()
                    e.nativeEvent.stopPropagation()
                    e.stopPropagation()

                }} >
                    <table style={{ border: "none", width: "100%" }}>
                        <thead>

                            {ifNotFCL() ?
                                <tr>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th colSpan='2' style={{ border: "solid 0.5px #4BA7DD", backgroundColor: "#4BA7DD", color: "#fff", fontWeight: "900", padding: "10px", textAlign: "center" }} >Per Unit</th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                </tr> : <></>
                            }
                            <tr style={{ fontWeight: "900", border: "solid 0.5px #D4D4D4" }}>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>ID</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", width: '20rem' }}>Charge Description</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>On Account</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>Currency</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'center' }}>Per Kg</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'center' }}>Minimum</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'center' }}>Per AWB</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right' }}>Total</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'center' }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                imChargesStore[key].map((e, i) => {
                                    {
                                        return <tr key={e.id} style={{ border: "solid 0.5px #D4D4D4", backgroundColor: (i % 2) == 1 ? "#F3F3F3" : "none" }}>
                                            <td style={{ color: "#555555", padding: "10px" }}>{e.id}</td>
                                            <td style={{ color: "#555555", padding: "10px" }}><Te i={i} name='chargeDescription' /></td>
                                            <td style={{ color: "#555555", padding: "10px" }}><Ts i={i} name='onaccount' dataList={onaccount} /></td>
                                            <td style={{ color: "#555555", padding: "10px" }}><Ts i={i} name='currency' dataList={configStore.getCurrencyList()} /></td>
                                            <td style={{ color: "#555555", padding: "10px", textAlign: 'center' }}><Tn i={i} name='perKg' /></td>
                                            <td style={{ color: "#555555", padding: "10px", textAlign: 'center' }}><Tn i={i} name='minimum' /></td>
                                            <td style={{ color: "#555555", padding: "10px", textAlign: 'center' }}><Tn i={i} name='perAWB' /></td>
                                            <td style={{ color: "#555555", padding: "10px", textAlign: 'right' }}>{
                                                (e.total != 0 && e.currency != '') ? Utils.N(e.total, e.currency) : ''
                                            }</td>
                                            <td style={{ color: "#555555", padding: "10px", textAlign: 'center' }}>
                                                <div className="field has-addons">

                                                    <p className="control">
                                                        <button className="button is-danger is-inverted"
                                                            onClick={() => {
                                                                deleteRec(e.id)
                                                                setSpace(space === '' ? ' ' : '')
                                                            }}>
                                                            <span className="icon">
                                                                <i className="fas fa-trash"></i>
                                                            </span>
                                                        </button>
                                                    </p>

                                                    {
                                                        i === imChargesStore[key].length - 1 &&
                                                        (
                                                            <p className="control">
                                                                <button className="button is-success is-inverted"
                                                                    onClick={() => {
                                                                        let obj = imChargesStore.newRec
                                                                        obj = { ...obj }
                                                                        airChargesBookingStore[key].push({ ...obj, id: imChargesStore[key].length + 1 })
                                                                        setSpace(space === '' ? ' ' : '')
                                                                    }}>
                                                                    <span className="icon is-small">
                                                                        <i className="fas fa-plus"></i>
                                                                    </span>
                                                                </button>
                                                            </p>
                                                        )
                                                    }
                                                </div>
                                            </td>
                                        </tr>
                                    }
                                }
                                )
                            }
                            <tr style={{ border: "solid 0.5px #D4D4D4" }}>
                                <td colSpan={7} style={{ textAlign: 'right', color: "#555555", padding: "10px", fontWeight: "900" }}>Total of On Your Account : </td>
                                <td style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right', fontSize: '1.1rem', fontWeight: "900" }}><strong>{Utils.N(grandTotal)}</strong></td>
                                <td rowSpan={(conTotal && shipTotal) ? 4 : (conTotal || shipTotal) ? 3 : 2} style={{ textAlign: 'center' }}>
                                    <button className="button is-info is-inverted"

                                        onClick={(e) => {
                                            e.nativeEvent.preventDefault()
                                            e.preventDefault()
                                            e.nativeEvent.stopPropagation()
                                            e.stopPropagation()

                                            cargoStore.calculateCargoTotals()
                                            airChargesBookingStore.calculateChargesTotalsindex(key)
                                            calculateFinalTotal()
                                            setSpace(space === '' ? ' ' : '')
                                        }}>
                                        <span className="icon is-small">
                                            <i className="fas fa-calculator"></i>
                                        </span>
                                    </button>
                                </td>
                            </tr>
                            {
                                shipTotal > 0 &&
                                <tr style={{ border: "solid 0.5px #D4D4D4" }}>
                                    <td colSpan={7} style={{ textAlign: 'right', color: "#555555", padding: "10px", fontWeight: "900" }}>Total of On Shipper's Account : </td>
                                    <td style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right', fontSize: '1.1rem', fontWeight: "900" }}><strong>{Utils.N(shipTotal)}</strong></td>
                                </tr>
                            }
                            {
                                conTotal > 0 &&
                                <tr style={{ border: "solid 0.5px #D4D4D4" }}>
                                    <td colSpan={7} style={{ textAlign: 'right', color: "#555555", padding: "10px", fontWeight: "900" }}>Total of On Consignee's Account : </td>
                                    <td style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right', fontSize: '1.1rem', fontWeight: "900" }}><strong>{Utils.N(conTotal)}</strong></td>
                                </tr>
                            }
                        </tbody>
                    </table></div></Card>
        </>
    )
}

export function FCLChargesComp(props) {

    const onaccount = ['On Your Account', `Consignee's Account`, `Shipper's Account`]
    useSnapshot(editStore)
    let key = "list"
    if (props.keylist != undefined) {
        key = props.keylist
    }
    let initialLength = "initialLength" + key.replace("list", "")
    const imContainerStore = useSnapshot(containerStore)
    const containerNames = imContainerStore.list.map(e => e.containerType)
    let [space, setSpace] = useState('')
    if (fclChargesBookingStore[key].length > 0) {
        let oldchargeskey = []
        Object.entries(fclChargesBookingStore[key][0]).filter(([key, value]) => {
            oldchargeskey.push(key)
        })
        let newchargeskey = []
        oldchargeskey.map(e => {
            if (e.indexOf("'") == -1) {
                newchargeskey.push(e)
            } else {
                containerNames.map(f => {
                    if (e.indexOf(f) > -1) {
                        newchargeskey.push(e)
                    }
                })
            }
        })
        let uniqueContainer = new Set(containerNames)
        if (oldchargeskey.sort().toString() != newchargeskey.sort().toString() && containerNames.length === uniqueContainer.size) {
            let newchargelist = []
            fclChargesBookingStore[key].map((e) => {
                var result = Object.fromEntries(newchargeskey.map(col => [col, e[col]]));
                newchargelist.push(result)
            })
            fclChargesBookingStore[key] = newchargelist;
        }

    }

    let imChargesStore = useSnapshot(fclChargesBookingStore)
    let a = imChargesStore.newRec
    let b = imChargesStore.editRec

    let list = fclChargesBookingStore[key]
    for (let i = 0; i < list.length; i++) {
        if (!list[i].onaccount || !list[i].onaccount.length) list[i].onaccount = 'On Your Account'
    }
    useEffect(() => {
        let entity = EntityV2Store.list.find((e) => e.entityId === editStore.contract.entityId)
        if (entity) {
            let sscope = editStore.contract.shipmentScope
            sscope = sscope.toLowerCase()
            let country = '' + entity.entityCountry
            country = country.toLowerCase()
            let cecisorigin = false
            let cecisdestination = false
            let por = ('' + editStore.contract.portOfLoading).toLowerCase()
            let pod = ('' + editStore.contract.finalPlaceOfDelivery).toLowerCase()
            let q = editStore.contract
            if (entity._id == "TBA" && q.isfromAgragaEnquiry != undefined && q.isfromAgragaEnquiry == 'Yes' && q.countryFromEnquiry != undefined) {
                country = q.countryFromEnquiry.toLowerCase()
            }
            if (country.includes('hong kong')) {
                cecisorigin = por.includes('hong kong')
                cecisdestination = pod.includes('hong kong')
            } else {
                cecisorigin = por.includes(country)
                cecisdestination = pod.includes(country)
            }

            fclChargesBookingStore[key].map((e) => {
                if (sscope.length != 0 && country.length != 0 && por.length != 0 && pod.length != 0) {
                    if (e.onaccount != undefined) {
                        if (onaccount.indexOf(e.onaccount) == -1) {
                            e.onaccount = "On Your Account"
                        }
                    }
                }
                return e
            })
        }
        console.log('DETECTED CHANGES=', editStore.contract.entityId, editStore.contract.portOfReceipt, editStore.contract.portOfDischarge)
    }, [
        editStore.contract.entity, editStore.contract.entityId, editStore.contract.portOfLoading,
        editStore.contract.finalPlaceOfDelivery, editStore.contract.shipmentScope
    ])
    const deleteRec = (id) => {
        //if (id <= imChargesStore[initialLength]) return
        const index = fclChargesBookingStore[key].findIndex(e => e.id === id)
        let records = fclChargesBookingStore[key]
        records = [...records]
        records.splice(index, 1)
        for (let i = 0; i < records.length; i++) {
            records[i].id = i + 1
        }
        if (id <= fclChargesBookingStore[initialLength]) {
            fclChargesBookingStore[initialLength] = fclChargesBookingStore[initialLength] - 1
        }
        fclChargesBookingStore[key] = records
        if (fclChargesBookingStore[key].length == 0) {
            let obj = imChargesStore.newRec
            obj = { ...obj }
            fclChargesBookingStore[key].push({ ...obj, id: fclChargesBookingStore[key].length + 1 })
        }
        //console.log('AFTER DELETE=', JSON.stringify(fclChargesBookingStore.cargoList))
    }
    const Ts = ({ i, name, dataList }) => <TableSelect
        record={fclChargesBookingStore[key][i]} name={name} dataList={dataList} isValid={chargesBookingValidationStore.isValidCharge(name, i, key)} />
    const Te = ({ i, name }) => {
        const e = fclChargesBookingStore[key][i]
        if (name === 'chargeDescription' && i < fclChargesBookingStore[initialLength])
            return <TableLabel record={fclChargesBookingStore[key][i]} name={name} />
        return (
            <TableComboInput
                record={fclChargesBookingStore[key][i]} name={name} dataList={configStore.getChargeDescriptionList('fcl')} isValid={chargesBookingValidationStore.isValidCharge(name, i, key)} />
            // <TableEdit record={fclChargesBookingStore[key][i]} name={name} isValid={chargesBookingValidationStore.isValidCharge(name, i,key)}/>
        )
    }
    const Tn = ({ i, name }) => {
        const e = fclChargesBookingStore[key][i]
        let disabled = false
        if (e.disabled) {
            for (let i = 0; i < e.disabled.length; i++) {
                if (name.endsWith(e.disabled[i])) {
                    disabled = true
                    break
                }
            }
        }
        if (disabled)
            return (
                <input disabled='true' style={{ width: '3rem', backgroundColor: '#dddddd', border: 'none' }} />
            )
        else return (
            <TableEdit record={fclChargesBookingStore[key][i]} name={name} type='number' isValid={chargesBookingValidationStore.isValidCharge(name, i, key)} />
        )
    }

    let grandTotal = {}
    let cTotal = {}
    let sTotal = {}
    let cPresent = false
    let sPresent = false
    containerStore.list.map(c => {
        grandTotal[c.containerType] = 0.0
        cTotal[c.containerType] = 0.0
        sTotal[c.containerType] = 0.0
    })
    fclChargesBookingStore[key].map(e => {
        let erate = configStore.getExchangeRateinr(e)
        if (!erate || erate === 0) erate = 1.0
        containerStore.list.map(c => {
            let totalField = c.containerType + 'total'
            if (e.onaccount && e.onaccount.startsWith('Cons')) {
                cPresent = true
                cTotal[c.containerType] += parseFloat(e[totalField]) * erate
            }
            else if (e.onaccount && e.onaccount.startsWith('Ship')) {
                sPresent = true
                sTotal[c.containerType] += parseFloat(e[totalField]) * erate
            }
            else grandTotal[c.containerType] += parseFloat(e[totalField]) * erate
        })
    })
    if (fclChargesBookingStore[key].length > 0) {
        fclChargesBookingStore.defaultValueCalcindex(key) // Need to calculate for validation
    }
    return (
        <>
            <hr />
            <Card onClick={(e) => {
                e.nativeEvent.preventDefault()
                e.preventDefault()
                e.nativeEvent.stopPropagation()
                e.stopPropagation()

            }} >
                <span><img src={chargedetails} /></span><Headspan color="#00000" fontSize="14px" fontWeight="900" data={" Charge Details" + (props.heading != undefined && props.heading.length > 0 ? " - " + props.heading : "")} />
                <AiChargeParse historyScope="quickQuote" historyKey={key} shipmentType="FCL" containerTypes={containerNames} onCharges={(l) => fillChargesStore(fclChargesBookingStore, key, l, () => fclChargesBookingStore.calculateChargesTotalsindex(key, editStore.contract.emptycontainerweight))} /><AiChargeHistory scope="quickQuote" chargeKey={key} />
                <div className="table-container" onClick={(e) => {
                    e.nativeEvent.preventDefault()
                    e.preventDefault()
                    e.nativeEvent.stopPropagation()
                    e.stopPropagation()

                }} >
                    <table style={{ border: "none", width: "100%" }}>
                        <thead>
                            {
                                (containerNames.length > 0) ? <tr>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    {containerNames.map(e => (
                                        <>
                                            <td style={{ border: "solid 0.5px #4BA7DD", backgroundColor: "#4BA7DD", color: "#fff", fontWeight: "900", padding: "10px", textAlign: "center" }} colSpan={3}>{e}</td>
                                            <th></th>
                                        </>
                                    ))}
                                    <th></th>
                                </tr> : ""
                            }
                            <tr style={{ fontWeight: "900", border: "solid 0.5px #D4D4D4" }}>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>ID</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>Charge Description</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>On Account</th>
                                <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px" }}>Currency</th>
                                {containerNames.map(e => (
                                    <>
                                        <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'center' }}>Per Container</th>
                                        <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'center' }}>Per BL</th>
                                        <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'center' }}>Per Ton</th>
                                        <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right' }}>Total</th>
                                    </>
                                ))}
                                {
                                    (containerNames.length > 0) ?
                                        <th style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'center' }}>Action</th> : ""}
                            </tr>
                        </thead>
                        <tbody>
                            {
                                imChargesStore[key].map((e, i) => {
                                    {
                                        return <tr key={e.id} style={{ border: "solid 0.5px #D4D4D4", backgroundColor: (i % 2) == 1 ? "#F3F3F3" : "none" }}>
                                            <td style={{ color: "#555555", padding: "10px" }}>{e.id}</td>
                                            <td style={{ color: "#555555", padding: "10px" }}><Te i={i} name='chargeDescription' /></td>
                                            <td style={{ color: "#555555", padding: "10px" }}><Ts i={i} name='onaccount' dataList={onaccount} /></td>
                                            <td style={{ color: "#555555", padding: "10px" }}><Ts i={i} name='currency' dataList={currencyList} /></td>
                                            {containerNames.map(e1 => (
                                                <>
                                                    <td style={{ color: "#555555", padding: "10px", textAlign: 'center' }}><Tn i={i} name={e1 + 'perWM'} /></td>
                                                    <td style={{ color: "#555555", padding: "10px", textAlign: 'center' }}><Tn i={i} name={e1 + 'perShipment'} /></td>
                                                    <td style={{ color: "#555555", padding: "10px", textAlign: 'center' }}><Tn i={i} name={e1 + 'perTon'} /></td>
                                                    <td style={{ color: "#555555", padding: "10px", textAlign: 'right' }}>
                                                        {
                                                            (e[e1 + 'total'] != 0 && e.currency != '') ?
                                                                Utils.N(e[e1 + 'total'], e.currency) : ''
                                                        }
                                                    </td>
                                                </>
                                            ))}
                                            {
                                                (containerNames.length > 0) ?
                                                    <td style={{ color: "#555555", padding: "10px", textAlign: 'center' }}>
                                                        <div className="field has-addons">


                                                            <p className="control">
                                                                <button className="button is-danger is-inverted"
                                                                    onClick={() => {
                                                                        deleteRec(e.id)
                                                                        setSpace(space === '' ? ' ' : '')
                                                                    }}>
                                                                    <span className="icon">
                                                                        <i className="fas fa-trash"></i>
                                                                    </span>
                                                                </button>
                                                            </p>

                                                            {
                                                                i === imChargesStore[key].length - 1 && (
                                                                    <p className="control">
                                                                        <button className="button is-success is-inverted"
                                                                            onClick={(e) => {
                                                                                e.nativeEvent.preventDefault()
                                                                                e.preventDefault()
                                                                                e.nativeEvent.stopPropagation()
                                                                                e.stopPropagation()
                                                                                let obj = imChargesStore.newRec
                                                                                obj = { ...obj }
                                                                                fclChargesBookingStore[key].push({ ...obj, id: imChargesStore[key].length + 1 })
                                                                                imChargesStore.defaultValueCalcindex(key)
                                                                                setSpace(space === '' ? ' ' : '')
                                                                            }}>
                                                                            <span className="icon is-small">
                                                                                <i className="fas fa-plus"></i>
                                                                            </span>
                                                                        </button>
                                                                    </p>
                                                                )
                                                            }
                                                        </div>
                                                    </td> : ""
                                            }

                                        </tr>
                                    }
                                }
                                )
                            }
                            {
                                (containerNames.length > 0) ? <>
                                    <tr style={{ border: "solid 0.5px #D4D4D4" }}>
                                        <td colSpan={4} style={{ textAlign: 'right', color: "#555555", padding: "10px", fontWeight: "900" }}>On Your Account</td>
                                        {
                                            containerStore.list.map(c => {
                                                return (
                                                    <>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td style={{ textAlign: 'right' }}>
                                                            <strong>
                                                                {Utils.N(grandTotal[c.containerType])}
                                                            </strong>
                                                        </td>
                                                    </>
                                                )
                                            })
                                        }
                                        <td rowSpan={(cPresent && sPresent) ? 4 : (cPresent || sPresent) ? 3 : 2} style={{ textAlign: 'center' }}>
                                            <button className="button is-info is-inverted"

                                                onClick={() => {
                                                    fclChargesBookingStore.calculateChargesTotalsindex(key, editStore.contract.emptycontainerweight);
                                                    setSpace(space === '' ? ' ' : '')
                                                }}>
                                                <span className="icon is-small">
                                                    <i className="fas fa-calculator"></i>
                                                </span>
                                            </button>
                                        </td>
                                    </tr>
                                    {
                                        cPresent &&
                                        <tr style={{ border: "solid 0.5px #D4D4D4" }}>
                                            <td colSpan={4} style={{ textAlign: 'right', color: "#555555", padding: "10px", fontWeight: "900" }}>On Consignee's Account</td>
                                            {
                                                containerStore.list.map(c => {
                                                    return (
                                                        <>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right', fontSize: '1.1rem', fontWeight: "900" }}>
                                                                <strong>
                                                                    {Utils.N(cTotal[c.containerType])}
                                                                </strong>
                                                            </td>
                                                        </>
                                                    )
                                                })
                                            }
                                        </tr>
                                    }
                                    {
                                        sPresent &&
                                        <tr style={{ border: "solid 0.5px #D4D4D4" }}>
                                            <td colSpan={4} style={{ textAlign: 'right', color: "#555555", padding: "10px", fontWeight: "900" }}>On Shipper's Account</td>
                                            {
                                                containerStore.list.map(c => {
                                                    return (
                                                        <>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, padding: "10px", textAlign: 'right', fontSize: '1.1rem', fontWeight: "900" }}>
                                                                <strong>
                                                                    {Utils.N(sTotal[c.containerType])}
                                                                </strong>
                                                            </td>
                                                        </>
                                                    )
                                                })
                                            }
                                        </tr>
                                    }
                                </> : ""}

                        </tbody>
                    </table></div></Card>
        </>
    )
}
